export default __webpack_public_path__ + "static/media/Marlena.f981310e.jpg";